import { useCartTotal } from '@/js/vue/composable/cart-total.ts';

const FORM_SELECTOR = '.js-product-cart-form';
const formElement = document.querySelector<HTMLFormElement>(FORM_SELECTOR);

export function initProductCartForm() {
  if (!formElement)
    return;
  const { addProductItem } = useCartTotal();
  // eslint-disable-next-line ts/no-misused-promises
  formElement.addEventListener('submit', async (event) => {
    event.preventDefault();
    const formData = new FormData(formElement);
    const productId = Number(formData.get('product_id'));
    const quantity = Number(formData.get('quantity'));
    await addProductItem(productId, quantity);
  });
}
